import { SignInForm } from '@components/SignInForm'
import { Container, Stack } from '@mantine/core'
import { PageContentShade } from '@packages/ui'

export const SignIn = () => {
  return (
    <Container>
      <Stack maw={400} mx="auto" mt={50}>
        <PageContentShade>
          <SignInForm />
        </PageContentShade>
      </Stack>
    </Container>
  )
}
